"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StateMachine = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var StateMachine =
/*#__PURE__*/
function (_React$Component) {
  _inherits(StateMachine, _React$Component);

  function StateMachine(props) {
    var _this;

    _classCallCheck(this, StateMachine);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StateMachine).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "createTransitionToFn", function (currentState) {
      return function (newState) {
        if (!(currentState.validTransitions && currentState.validTransitions.includes(newState))) {
          throw new Error("'".concat(newState, "' is not listed in transitions array for state ").concat(currentState.name));
        }

        _this.transition(currentState.name, newState);
      };
    });

    _this.transition('<no state>', _this.props.getCurrentState());

    _this.update();

    return _this;
  }

  _createClass(StateMachine, [{
    key: "transition",
    value: function transition(oldState, newState) {
      var nextState = this.props.states.find(function (state) {
        return state.name === newState;
      });

      if (!nextState) {
        var validStates = this.props.states.map(function (state) {
          return state.name;
        }).join(", ");
        throw new Error("Tried to transition from state '".concat(oldState, "' to '").concat(newState, "'. Valid states are: [").concat(validStates, "]"));
      }

      this.props.setNewState(newState);

      if (nextState.beforeRender) {
        nextState.beforeRender(_objectSpread({}, this.props.data, {
          currentState: newState,
          transitionTo: this.createTransitionToFn(nextState)
        }));
      }
    }
  }, {
    key: "update",
    value: function update() {
      var _this$props = this.props,
          getCurrentState = _this$props.getCurrentState,
          states = _this$props.states,
          data = _this$props.data;
      var currentStateName = getCurrentState();
      var currentState = states.find(function (state) {
        return state.name === currentStateName;
      });

      if (Array.isArray(currentState.autoTransitions)) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = currentState.autoTransitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var transition = _step.value;

            if (transition.test(data)) {
              this.transition(currentStateName, transition.newState);
              return;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.update();
    }
  }, {
    key: "render",
    value: function render() {
      var currentStateName = this.props.getCurrentState();
      var currentState = this.props.states.find(function (state) {
        return state.name === currentStateName;
      });

      var additionalProps = _objectSpread({}, this.props.data, {
        currentState: currentStateName,
        transitionTo: this.createTransitionToFn(currentState)
      });

      if (currentState.render) return currentState.render(additionalProps);
      if (currentState.component) return _react.default.createElement(currentState.component, additionalProps);
      throw new Error("Neither a valid render or component property was found for state '".concat(currentStateName, "'"));
    }
  }]);

  return StateMachine;
}(_react.default.Component);

exports.StateMachine = StateMachine;

var autoTransitionsPropTypes = _propTypes.default.arrayOf(_propTypes.default.shape({
  test: _propTypes.default.func.isRequired,
  newState: _propTypes.default.string.isRequired
}));

var statePropTypes = _propTypes.default.arrayOf(_propTypes.default.shape({
  name: _propTypes.default.string.isRequired,
  autoTransitions: autoTransitionsPropTypes,
  validTransitions: _propTypes.default.arrayOf(_propTypes.default.string),
  beforeRender: _propTypes.default.func,
  component: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  render: _propTypes.default.func
})).isRequired;

StateMachine.propTypes = {
  data: _propTypes.default.object.isRequired,
  getCurrentState: _propTypes.default.func.isRequired,
  setNewState: _propTypes.default.func.isRequired,
  states: statePropTypes
};


//////////////////
// WEBPACK FOOTER
// ../react-state-machine/lib/index.js
// module id = 24
// module chunks = 0